export interface IInner {}

export interface IOutter {}

export type IProps = IInner & IOutter;

export enum ESearchType {
	ADDRESS = 'ADDRESS',
	DISTRICT_ID = 'DISTRICT_ID',
	OWNERSHIP_TYPE = 'OWNERSHIP_TYPE',
	FACILITY_TYPE = 'FACILITY_TYPE',
	PROVIDED_DATE = 'PROVIDED_DATE',
	PROVIDER_TYPE = 'PROVIDER_TYPE',
	PROVIDER_NAME = 'PROVIDER_NAME',
	PROVIDER_NATIONAL_CODE = 'PROVIDER_NATIONAL_CODE',
	PROVIDER_PHONE = 'PROVIDER_PHONE',
	PROVIDER_ADDRESS = 'PROVIDER_ADDRESS',
	ASSIGN_CNT = 'ASSIGN_CNT',
	INSPECTION_DATE = 'INSPECTION_DATE',
	REGIST_DT = 'REGIST_DT',
	UPDATE_DT = 'UPDATE_DT',
	PROVIDER_TABLE = 'PROVIDER_TABLE',
	ID = 'ID',
	LODGING_COST = 'LODGING_COST',
	MEAL_COST = 'MEAL_COST',
}
